import { Col } from "@/common/css";
import Button from "@/common/ui/Button";
import { Container } from "@/common/ui/container";
import { LightText2 } from "@/common/ui/Text";
import React from "react";

interface ConfirmationAlertModalProps {
  onClose?: (props?: any) => void;
  handleCancel: () => void;
  handleConfirm: any;
  modalProps: {
    descriptions: string[];
    submitText?: string;
    submitBtnVariant?: any;
  };
  isLoading?: boolean;
}

const ConfirmationAlertModal: React.FC<ConfirmationAlertModalProps> = ({ handleCancel, handleConfirm, modalProps, isLoading = false }) => {
  const { descriptions = [], submitText, submitBtnVariant } = modalProps;
  return (
    <Container.ContentBox>
      <Container.Content className="pb-4 pt-2 px-4">
        {descriptions?.length > 0 && (
          <Col className="gap-y-2">
            {descriptions.map((d, i) => (
              <LightText2 key={`description${i}`} text={d} className="" />
            ))}
          </Col>
        )}
      </Container.Content>
      <Container.Separator />
      <div className={`flex justify-end gap-4 w-full p-4`}>
        <Button variant="outline" size="small" disabled={isLoading} onClick={handleCancel}>
          Cancel
        </Button>
        <Button variant={submitBtnVariant ? submitBtnVariant : "outline-danger"} size="small" isLoading={isLoading} onClick={handleConfirm} className="">
          {submitText || "Confirm"}
        </Button>
      </div>
    </Container.ContentBox>
  );
};

export default ConfirmationAlertModal;
